// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: Record<string, any> = {
  production: false,
  caasbaseUrl: 'https://miltenyi-dev-caas-api.e-spirit.cloud',
  caasProject: '1ca47eac-be5e-4ee5-b950-89225b17941c',
  caasApiKey: '9775ab6c-31aa-4897-b2aa-2448b8808eaa',
  caasTenantId: 'miltenyi-dev',
  caasPreviewUrl: 'https://miltenyi-dev-caas-api.e-spirit.cloud/miltenyi-dev/1ca47eac-be5e-4ee5-b950-89225b17941c.preview.content',
  navigationServicePreviewUrl: 'https://miltenyi-dev-navigationservice.e-spirit.cloud/navigation/preview.1ca47eac-be5e-4ee5-b950-89225b17941c',
  navigationServiceReleaseUrl: '/navigation/release.1ca47eac-be5e-4ee5-b950-89225b17941c',
  releaseContent: 'release.content',
  previewContent: 'preview.content',
  movingImage: {
    apiUrl: '//d.video-cdn.net/play',
    flashPath: '//e.video-cdn.net/v2/',
    configType: 'vmpro',
    tokenUrl: 'https://miltenyibiotectest.apimanagement.eu2.hana.ondemand.com/MovingImage/GetToken',
    apiBaseUrl: 'https://api.video-cdn.net',
    videoManagerId: 556,
    player: 'EzknAzMPePoodx8g4cLsCe',
    script: 'https://e.video-cdn.net/v2/embed.js'
  },
  webformsUrlPreview: 'https://miltenyidev.e-spirit.hosting/mwf_preview/servlet/form',
  webformsUrlLive: '/mwf_live/servlet/form',
  marketingCloudEndpoint: 'https://miltenyibiotectest.apimanagement.eu2.hana.ondemand.com/PersonalData',
  smartSearchUrl: 'https://miltenyi-dev-search-api.e-spirit.cloud',
  smartSearchDefaultCaasGenerator: 'FS_DefaultCaasGenerator',
  smartSearchPIMIdentifierSearch: 'GoToPimIdentifierSearch',
  smartSearchByIdentifierSearch: 'SearchByIdentifier',
  smartSearchMiVideoSearch: 'FS_MovingImageVideosGenerator',
  smartSearchMiChannelSearch: 'FS_MovingImageChannelsGenerator',
  smartSearchCertificates: 'FS_CantoCerts',
  smartSearchClinicalChanges: 'FS_CantoClinicalChanges',
  smartSearchJobs: 'FS_JobsMiltenyi',
  smartSearchDocuments: 'FS_CantoDocuments',
  classificationCodes: {
    abHeader: '60210100',
    sizeFilter: '50072167',
    stamps: '60210126',
    stampRecombinant: 'miltenyiWebshopClassification/1.0/60210126.71000274',
    stampExtendedValidation: 'miltenyiWebshopClassification/1.0/60210126.70000408',
    alterNativeNames: 'miltenyiWebshopClassification/1.0/60211634.70000155',
    prov: '50000005',
    orderInformationCode: '60211634'
  },
  university: {
    csodApiUrl: 'https://miltenyibiotectest.apimanagement.eu2.hana.ondemand.com/TrainingsAndSessions',
    trainingRegistrationUrl: 'https://miltenyi.csod.com/samldefault.aspx?ouid=5&returnURL=%2FDeepLink%2FProcessRedirect.aspx%3Fmodule%3Dlodetails%26lo%3D',
    assetsUrl: 'https://assets.miltenyibiotec.com/mu-custom-img'
  },
  freshChat: {
    bot: {
      src: 'https://cdn.euc-freshbots.ai/assets/share/js/freshbots.min.js',
    },
    widget: {
      src: 'https://miltenyibiotec-help.freshchat.com/js/widget.js'
    }
  },
  google: {
    gtmId: 'GTM-TBJ5SR4'
  },
  myAccount: {
    newsletterUrl: 'https://spa-dev.miltenyibiotecdev.com/resources/newsletter-sign-up.html',
    universityUrl: 'https://miltenyi-pilot.csod.com/samldefault.aspx?ouid=3',
    mpupUrl: ' https://www.miltenyibiotec.com/products/macs-pick-up-point.html',
    hostedPages: {
      baseUrl: 'https://myaccountlogin-az-dev.miltenyibiotec.com/',
      profilePage: 'profile.html',
      registerPage: 'register.html',
      registerMuParams: '?incomplete&client=mu'
    }
  },
  oAuth: {
    clientId: 'HgD32NBRxCmj2giG_HfXMpdb',
    clientSecret: '9DAXcJ_1Dx5cBe8gena49xkdz-eOLPFm2rpcC91t2dfEfpfwnzGy1TuImGmdD7dJOb9RihZ_5L_wOVPScA8RsA',
    scope: 'openid email profile profile_extra',
    oauthUrl: 'https://fidm.eu1.gigya.com/',
    authorizePath: 'oidc/op/v1.0/4_81JM5RsWAw1n20obwo_FYg/authorize',
    tokenPath: 'oidc/op/v1.0/4_81JM5RsWAw1n20obwo_FYg/token',
    revokePath: 'oidc/op/v1.0/4_81JM5RsWAw1n20obwo_FYg/revoke',
    logoutPath: '',
    baseUrl: 'https://fidm.eu1.gigya.com/',
    userinfoPath: 'oidc/op/v1.0/4_81JM5RsWAw1n20obwo_FYg/userinfo',
    prefix: '',
    disablePKCE: ''
  },
  occ: {
    baseUrl: 'https://d2-api.miltenyibiotecdev.com',
    prefix: '/occ/v2/',
    productCatalog: 'miltenyiWebshopProductCatalog'
  },
  mpup: {
    baseUrl: 'https://miltenyibiotectest.apimanagement.eu2.hana.ondemand.com/dev',
    productPageUrl: 'https://spa-dev.miltenyibiotecdev.com/'
  }
}

environment.proxies = [
  {
    // web workers
    context: [
      '/navigation/**',
      '/mwf_live/servlet/**'
    ],
    target: 'https://spa-dev.miltenyibiotecdev.com',
    changeOrigin: true,
    secure: true,
    logger: console
  },
  {
    disabled: true,
    context: [
      '/rest/v2/**',
      '/occ/v2/**',
      '/authorizationserver/**',
      '/medias/**',
      '/assistedservicewebservices/**'
    ],
    target: environment.occ.baseUrl,
    changeOrigin: true,
    secure: true,
    logger: console,
    cache: true,
    cacheBlacklist: [
      /\/users\//,
      /\/checkout\//,
      /\/medias\//
    ]
  },
  {
    disabled: false,
    context: ['/v1/*'],
    target: environment.movingImage.apiBaseUrl,
    secure: true,
    changeOrigin: true,
    cache: false
  },
  {
    disabled: false,
    context: ['/auth/*'],
    target: 'https://login.movingimage.com',
    secure: true,
    changeOrigin: true,
    cache: false
  }
]

environment.ssr = [
  /\/UN-en\/?$/,
  /\/SG-en\/?$/,
  /\/KR-en\/?$/,
  /\/CN-en\/?$/,
  /\/JP-en\/?$/,
  /\/HK-en\/?$/,
  /\/DE-en\/?$/,
  /\/CH-en\/?$/,
  /\/AT-en\/?$/,
  /\/DK-en\/?$/,
  /\/FI-en\/?$/,
  /\/NO-en\/?$/,
  /\/SE-en\/?$/,
  /\/ES-en\/?$/,
  /\/FR-en\/?$/,
  /\/BE-en\/?$/,
  /\/LU-en\/?$/,
  /\/NL-en\/?$/,
  /\/GB-en\/?$/,
  /\/IE-en\/?$/,
  /\/IT-en\/?$/,
  /\/AU-en\/?$/,
  /\/CA-en\/?$/,
  /\/US-en\/?$/,
  /\/IN-en\/?$/
]

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

